var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompetingLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 417,
    viewBox: "0 0 208 417",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h208c0 114.878-93.122 208-208 208V0zM0 208h208c0 115.43-93.122 209-208 209V208z",
    fill: "#fff"
  })));
}
export default SvgCompetingLeft;